import { Col, Form, Input, Modal, Row, Button } from "antd";
import React from "react";
import { useEffect } from "react";
import { PutBankACApi } from "../../api/listBankAC";
import { useState } from "react";
import { ToastError, ToastSuccess } from "../../components/ToastSwal";

const ModalEditBankAccount = ({
  isModalOpenEditBank,
  handleOkEditBank,
  setIsModalOpenEditBank,
  idEditBankAC,
  dataInforBankAC,
  fetchListDataBankAC,
}) => {
  const [form] = Form.useForm();
  const [loadings, setLoadings] = useState(false);

  const handleCancelEditBank = () => {
    setIsModalOpenEditBank(false);
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
    if (isModalOpenEditBank) {
      form.setFieldsValue({
        codebank: dataInforBankAC.codebank,
        namebank: dataInforBankAC.namebank,
        accountbank: dataInforBankAC.accountbank,
      });
    }
  }, [isModalOpenEditBank, dataInforBankAC, form]);

  const onFinish = (values) => {
    var FormData = require("form-data");
    var data = new FormData();
    setLoadings(!loadings);
    data.append("id", idEditBankAC);
    data.append("message", "update");
    data.append("codebank", values.codebank);
    data.append("namebank", values.namebank);
    data.append("accountbank", values.accountbank);

    // currentDuAn
    PutBankACApi(data)
      .then((res) => {
        ToastSuccess.fire({
          icon: "success",
          title: "Cập nhật Bank Account thành công",
        });
        setLoadings(false);
        fetchListDataBankAC();
        handleCancelEditBank();
      })
      .catch((error) => {
        ToastError.fire({
          icon: "error",
          title: error.data.message,
        });
      });
  };

  return (
    <Modal
      title="EDIT BANK ACCOUNT"
      open={isModalOpenEditBank}
      onOk={handleOkEditBank}
      onCancel={handleCancelEditBank}
      footer={false}
      width={800}
      forceRender={true}
      className="headerTitleModal"
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        // validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row>
          <Col span={11}>
            <Form.Item
              label="Bank Account Name"
              name="namebank"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Bank Account Name!",
                },
              ]}
            >
              <Input size="large" placeholder="Bank Account Name" />
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col span={11}>
            <Form.Item
              label="Bank Account Code"
              name="codebank"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Bank Account Code!",
                },
              ]}
            >
              <Input size="large" placeholder="Bank Account Code" />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label="Bank Account Number"
              name="accountbank"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Bank Account Number!",
                },
              ]}
            >
              <Input size="large" placeholder="Bank Account Number" />
            </Form.Item>
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              className="btnSaveModel"
              type="success"
              htmlType="submit"
              variant="contained"
              loading={loadings}
            >
              Save
            </Button>
            <Button
              className="btnCancelModel"
              variant="outlined"
              onClick={handleCancelEditBank}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalEditBankAccount;
